/**
 * Browser entry point.
 *
 * The theme is applied before React mounts for the same reason it is also
 * applied by an inline script in the head: a deferred module runs after the
 * first paint, and an operator who chose light on a dark machine would see dark
 * flash on every navigation.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/*
 * Primer first, our stylesheet second: primitives define every design token
 * (colors, radii, shadows, type) and styles.css consumes them as aliases —
 * the console carries no raw hex of its own on this branch.
 */
import '@primer/primitives/dist/css/primitives.css';
import '@primer/primitives/dist/css/functional/themes/light.css';
import '@primer/primitives/dist/css/functional/themes/dark.css';
import './styles.css';
import { App } from './ui/app.js';
import { applyTheme, readTheme } from './store.js';

applyTheme(readTheme());

const mount = document.getElementById('app');
if (mount === null) throw new Error('the console needs an element with id "app" to mount into');

createRoot(mount).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
